import Button from '../../../components/form-control/Button';
import Input from '../../../components/form-control/Input';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  rnplPreapproval,
} from '../../../api/requests';
import {
  getPhoneNumberFromShortCodeFormat,
  getSelectOptionsFromEnum,
  showToast
} from '../../../utils/miscFunctions';
import { useState } from 'react';
import { RNPL_PAYMENT_CHANNEL } from '../../../resources/enums';
import SelectDropdown from '../../../components/form-control/SelectDropdown';

interface EditLeadProps {
  onProceed: () => void;
  onClose: () => void;
  rnplApplicant: any;
}

const RNPLPreapproval = ({ onProceed, onClose, rnplApplicant }: EditLeadProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div className="">
      <Formik
        initialValues={{
          phoneNumber: getPhoneNumberFromShortCodeFormat(rnplApplicant?.customer?.phone),
          channel: ''
        }}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          phoneNumber: Yup.string().trim().required('Phone number is required.'),
          channel: Yup.string().trim().required('Network Channel is required.')
        })}
        onSubmit={(values) => {
          const payload: any = {
            phoneNumber: values.phoneNumber,
            channel: values.channel
          };

          const id = rnplApplicant.id;
          if (id) setLoading(true);
          rnplPreapproval(values.channel, rnplApplicant.applicationNumber, values.phoneNumber)
            .then((response: any) => {
              onProceed();
              showToast.success(response.message && 'RNPL updated successfully.');
            })
            .catch((error: any) => {
              showToast.error(error.description && 'Something went wrong');
            })
            .finally(() => setLoading(false));
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="p-8">
              <div className=" ">
                <p className="text-[24px] mb-10">Provide your mobile money details.</p>
                <div className="grid w-full grid-cols-1 md:grid-cols-1 gap-5  ">
                  <Input
                    type={'text'}
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Your mobile money wallet number"
                    placeholder="Phone number"
                    required
                    error={touched.phoneNumber ? errors.phoneNumber : undefined}
                    helperText={touched?.phoneNumber ? errors.phoneNumber : undefined}
                    className="rounded"
                  />

                  <SelectDropdown
                    name="channel"
                    listSelectedValue={values.channel}
                    onChange={(value: string) => {
                      setFieldValue('channel', value);
                    }}
                    label="Mobile Money network"
                    placeholder="Select network"
                    list={getSelectOptionsFromEnum(RNPL_PAYMENT_CHANNEL)}
                    required
                    error={touched.channel ? errors.channel : undefined}
                    helperText={touched?.channel ? errors.channel : undefined}
                    selectInputClassName="rounded"
                  />
                </div>
              </div>

              <div className="w-full flex gap-4 !mt-4">
                <Button
                type="button"
                label="Cancel"
                onClick={onClose}
                bgColor='secondary'
                  fullWidth
                
                />
                <Button
                label="Activate"
                  onClick={handleSubmit}
                bgColor='primary'
              fullWidth
                disabled={loading}
                loading={loading}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default RNPLPreapproval;
